import React, { useEffect, useState } from 'react';
import Header from '../../Header/Header';
import Footer from '../../Footer/Footer';
import axios from 'axios';
import { FaHome } from 'react-icons/fa';
import { IoIosArrowForward } from 'react-icons/io';

import facebook from './Images/facebook.png';
import insta from './Images/insta.png';
import linkdin from './Images/linkdin.svg';

interface CoordinatorItem {
  id: number;
  name: string;
  position: string;
  organization: string;
  Description: string;
  Profile_Picture: string;
  Facebook: string;
  Linkedin: string;
}

const Coordinator = () => {
  const [coordinators, setCoordinators] = useState<CoordinatorItem[]>([]);
  const [bannerdata, setBannerdata] = useState<any[]>([]);

  useEffect(() => {
    const fetchCoordinators = async () => {
      try {
        const res = await axios.get('https://rmbbackend.rmbjaipur.com/auth/allusersinfo');
        const list = Array.isArray(res.data) ? res.data : (res.data.data || []);

        // Filter ONLY Coordinators
        const filtered = list.filter((u: any) => {
          if (u.delete === 1) return false;
          const subRole = (u.sub_role || '').toLowerCase();
          const designation = (u.designation || '').toLowerCase();
          const role = (u.role || '').toLowerCase();

          return subRole.includes('coordinator') || designation.includes('coordinator') || role.includes('coordinator');
        });

        const mapped = filtered.map((u: any) => ({
          id: u.id,
          name: u.name,
          position: u.sub_role || u.designation || 'Committee Coordinator',
          organization: u.company_name || 'RMB Jaipur',
          Description: `${u.designation || u.company_name || 'Committee Coordinator'} • RMB Jaipur Active Coordinator`,
          Profile_Picture: u.profile
            ? (u.profile.startsWith('http') ? u.profile : `https://rmbbackend.rmbjaipur.com/${u.profile.replace(/\\/g, '/')}`)
            : 'https://via.placeholder.com/200?text=Coordinator',
          Facebook: u.social || '#',
          Linkedin: u.social || '#'
        }));

        setCoordinators(mapped);
      } catch (err) {
        console.error('Error fetching coordinators:', err);
      }
    };

    const fetchBanner = async () => {
      try {
        const response = await axios.get('https://rmbbackend.rmbjaipur.com/auth/directorbanner');
        setBannerdata(response.data || []);
      } catch (error) {
        console.error('Banner Not Found:', error);
      }
    };

    fetchCoordinators();
    fetchBanner();
  }, []);

  return (
    <div>
      <Header />

      {/* Hero Banner matching Leadership Page UI */}
      {bannerdata.length > 0 ? (
        bannerdata.map((items: any) => (
          <div
            key={items.id}
            className="w-full h-[451px] relative"
            style={{
              backgroundImage: `url(https://rmbbackend.rmbjaipur.com/${items.image.replace(/\\/g, '/')})`,
              backgroundPosition: 'center',
              backgroundSize: 'cover',
            }}
          >
            <div className="relative z-10 w-[100%] h-[100%] flex flex-col py-[20px] justify-center items-center">
              <h2 className="text-center sm:text-[61px] text-[48px] text-[#FDBC12] font-bold">
                Coordinators <span className="text-[#F1F4F9]">Team</span>
              </h2>
              <p className="text-[20px] text-[#CBD5E0] text-center lg:w-[80%]">
                Meet our dedicated RMB Jaipur chapter committee coordinators driving growth, attendance, and business.
              </p>
              <div className="flex bg-[#1E2A3A] border border-[#465468] rounded-md py-2 px-4 mt-4 text-[#64748B]">
                <a className="flex gap-x-3 items-center mr-3 active:text-[#F1F4F9]" href="/">
                  <FaHome /> Home
                </a>
                <a className="flex gap-x-3 items-center mr-3 active:text-[#F1F4F9]" href="/directors">
                  <IoIosArrowForward /> Directors
                </a>
                <span className="flex gap-x-3 items-center text-[#FDBC12]">
                  <IoIosArrowForward /> Coordinators
                </span>
              </div>
            </div>
          </div>
        ))
      ) : (
        <div className="w-full bg-[#1E2A3A] py-16 px-[8%] border-b border-[#465468] text-center">
          <h2 className="sm:text-[61px] text-[48px] text-[#FDBC12] font-bold">
            Coordinators <span className="text-[#F1F4F9]">Team</span>
          </h2>
          <p className="text-[20px] text-[#CBD5E0] text-center lg:w-[80%] mx-auto mt-2">
            Meet our dedicated RMB Jaipur chapter committee coordinators driving growth, attendance, and business.
          </p>
          <div className="inline-flex bg-[#101729] border border-[#465468] rounded-md py-2 px-4 mt-4 text-[#64748B] text-sm">
            <a className="flex gap-x-2 items-center mr-3 hover:text-white" href="/">
              <FaHome /> Home
            </a>
            <IoIosArrowForward className="mt-1" />
            <span className="text-[#FDBC12] font-bold ml-2">Coordinators</span>
          </div>
        </div>
      )}

      {/* Coordinators Grid matching Leadership Page UI */}
      <div className="bg-[#1E2A3A] py-14 px-[8%]">
        <div className="flex flex-wrap w-[100%] justify-between mb-6">
          <div className="sm:w-[50%]">
            <span className="text-[39px] leading-10 font-bold text-[#F1F4F9] ml-2">
              Coordinators
            </span>
            <span className="text-[#FDBC12] text-[39px] leading-10 font-bold pl-2">
              Team
            </span>
          </div>
        </div>

        <div className="w-[100%] flex flex-wrap justify-between mt-[50px] gap-y-10">
          {coordinators.length === 0 ? (
            <div className="text-slate-400 font-bold text-lg p-6">No coordinators assigned yet.</div>
          ) : (
            coordinators.map((data) => (
              <div key={data.id} className="flex flex-wrap lg:w-[48%] w-[100%] gap-4">
                <div className="w-[200px] h-[200px] p-3 border-2 border-[#FDBC12] rounded-full flex justify-center items-center shadow-lg">
                  <img
                    className="w-full h-full rounded-full object-cover"
                    src={data.Profile_Picture}
                    alt={data.name}
                    onError={(e) => { e.currentTarget.src = 'https://via.placeholder.com/200?text=Coordinator'; }}
                  />
                </div>
                <div className="sm:w-[60%] w-[100%] flex flex-col justify-center sm:mt-0 mt-4">
                  <h5 className="sm:text-[24px] text-[18px] font-semibold text-[#F5F5F5]">{data.name}</h5>
                  <p className="text-[14px] font-semibold text-[#FDBC12]">{data.position}</p>
                  <div className="w-[171px] h-[2px] bg-[#FDBC12] mt-4"></div>
                  <p className="text-[12px] text-[#94A2B8] mt-4 min-h-[75px]">{data.Description}</p>
                  <div className="flex items-center mt-3">
                    <img className="w-[24px] h-[24px] cursor-pointer" src={facebook} alt="Facebook" />
                    <img
                      className="w-[24px] h-[24px] ml-4 cursor-pointer"
                      src={insta}
                      alt="Instagram"
                      onClick={() => { window.location.href = `${data.Facebook}`; }}
                    />
                    <img
                      className="w-[24px] h-[24px] ml-4 cursor-pointer"
                      src={linkdin}
                      alt="LinkedIn"
                      onClick={() => { window.location.href = `${data.Linkedin}`; }}
                    />
                    <button
                      onClick={() => { window.location.href = `mailto:${data.name}`; }}
                      className="bg-[#FDBC12] w-[150px] py-2 rounded text-[#101729] text-[12px] font-bold ml-4 hover:bg-amber-400 transition"
                    >
                      Connect With Me
                    </button>
                  </div>
                </div>
              </div>
            ))
          )}
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default Coordinator;